export default (input: string) => /^\d+$/.test(input);
